<template>
  <div>
    <!-- 会员标识 -->
    <img v-if="props.type === SKU_TYPE.VIP" :style="style" :src="VIP_LIGHT" />
    <template v-else>
      <!-- 灵豆高亮标识 -->

      <div v-if="props.light" :class="$style.Content">
        {{ props.lingdouNum }}
        <img style="margin-left: 2px" :style="style" :src="LINGDOU_LIGHT" />
      </div>

      <!-- 灵豆置灰标识，带有灵豆不足提示 -->
      <Popover v-else-if="props.showPopover && !props.light" v-model:visible="visiblePopover">
        <template #content>
          <div :class="$style.LingdouPopover">
            <div style="margin-left: 4px">
              <div :class="$style.LingdouTip"
                ><img
                  style="width: 12px; height: 12px; margin-right: 4px"
                  :src="LINGDOU_GRAY"
                />灵豆不足。</div
              >
              <div
                :class="$style.Pay"
                @click="
                  () => {
                    visiblePopover = false;
                    props.openPayModal?.();
                  }
                "
                >购买灵豆，开启加速生成<RightOutlined
              /></div>
            </div>
          </div>
        </template>
        <div :class="$style.Content">
          <img :style="style" :src="LINGDOU_GRAY" />
        </div>
      </Popover>

      <!-- 灵豆置灰标识 -->
      <div v-else :class="$style.Content">
        <img :style="style" :src="LINGDOU_GRAY" />
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
  import { SKU_TYPE } from '../constants';
  import { RightOutlined } from '@ant-design/icons-vue';
  import { Popover } from 'ant-design-vue';
  import { ref, computed } from 'vue';

  const LINGDOU_LIGHT =
    'https://static.lingvisions.com/public/2ae5b9ac14f14cbca3a89722cf5a6e54.png';
  const LINGDOU_GRAY =
    'https://static.lingvisions.com/public/b6e84c6d90334001bd1256de9047a551.png';
  const VIP_LIGHT =
    'https://static.lingvisions.com/public/ebedccf4714f41ffaf1875530a86e4b9.png';

  const props = defineProps({
    size: {
      type: Number,
      default: 24,
    },
    light: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: null,
    },
    showPopover: {
      type: Boolean,
      default: false,
    },
    lingdouNum: {
      type: Number,
      default: null,
    },

    openPayModal: {
      type: Function,
      default: null,
    },
  });
  const visiblePopover = ref(false);

  const style = computed(() => ({
    width: props.size + 'px',
    height: props.size + 'px',
    minWidth: props.size + 'px',
    minHeight: props.size + 'px',
  }));
</script>

<style lang="less" module>
  .LingdouPopover {
    display: flex;
    align-items: center;
  }

  .Content {
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.85);
    font-size: 16px;
    font-weight: 400;
    line-height: 12px;
  }

  .LingdouTip {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.85);
  }

  .Pay {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgba(255, 177, 27, 1);
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    cursor: pointer;
  }
</style>
